import Api from "./Api";

export const AuthService = {

    login: async (email, password) => {

        const res = await Api.post("/admin-login", {
            email,
            password
        });

        return res.data;
    },

    verifyEmail: async (email) => {
        const res = await Api.post("/admin-verify-email", { email });
        return res.data;
    },

    resetPassword: async (email, password) => {
        const res = await Api.post("/admin-reset-password", { email, password });
        return res.data;
    }

};